import { RecurringOrdersService } from './../../shared/services/recurring-orders.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { RecurringOrder } from '@classes/recurring-order/recurring-order';
import { User } from '@classes/user/user';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UiService } from '@services/ui.service';
import { UsersService } from '@services/users.service';
import { AuthService } from '@services/auth.service';
import { RoleName } from '@enums/role-name.enum';
import { type } from 'os';
import { OrderType } from '@enums/order-type.enum';

@Component({
  selector: 'app-recurring-order-detail',
  templateUrl: './recurring-order-detail.component.html',
  styleUrls: ['./recurring-order-detail.component.scss']
})
export class RecurringOrderDetailComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  @ViewChild(MatAccordion) accordion: MatAccordion;

  order: RecurringOrder;
  isReadOnly = true;
  doesShowRoute = false;
  onEditMode = false;

  isRestricted: boolean;
  isSuperAdmin: boolean;
  isClient: boolean;
  isLoading = true;
  isLoadingSites = false;
  isLoadingEmail = false;
  showEmail = false;
  isDispatcher: boolean;
  hasScans = false;
  canEdit: boolean;
  invalidMessage = '';
  startTime = '';

  editSite: boolean;

  displayedColumns: string[] = ['firstname', 'birthname', 'lastname', 'birthdate', 'productType', 'quantity'];
  displayedColumnsHistory: string[] = ['status', 'comment', 'createdBy', 'createdOn'];
  disabledExportMessage = '';
  canExport = false;

  constructor(
    private route: ActivatedRoute,
    private ordersSrv: RecurringOrdersService,
    private uiSrv: UiService,
    private router: Router,
    private usersSrv: UsersService,
    private authSrv: AuthService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getRouteData();


    this.initSubscriptions();
    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.isRestricted = this.authSrv.getUser().role.name === RoleName.client || this.authSrv.getUser().role.name === RoleName.driver;
    this.isClient = this.authSrv.getUser().role.name === RoleName.client || this.authSrv.getUser().role.name === RoleName.admin_client;
    if (this.isClient) {
      this.displayedColumnsHistory = ['status', 'createdBy', 'createdOn'];
    }
    this.isSuperAdmin = this.authSrv.getUser().role.name === RoleName.bizzdev || this.authSrv.getUser().role.name === RoleName.super_admin || this.authSrv.getUser().role.name === RoleName.admin || this.authSrv.getUser().role.name === RoleName.admin_subcontractor;

    this.checkIfCanEdit();
    // this.minutesToAdd();
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { order: RecurringOrder }) => {
        this.order = data.order;
        this.isLoading = false;
      });
  }

  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
          this.isLoading = loadingState;
        })
    );

    this.subscription.add(
      this.ordersSrv.selectedRecurringOrderChanged
        .subscribe(selectedOrder => {
          this.order = selectedOrder;
          this.cdr.detectChanges();
          // this.onEditFinished();
        })
    );


  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  convertToISODate(time: string): string {
    const [hours, minutes] = time.split(':').map(Number);
    const now = new Date();
    const localDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);

    return localDate.toISOString();
  }

  getBack(): void {
    this.router.navigate(['/recurring-orders/list']);
  }


  get totalSteps(): number {
    return this.order.receivers.length + 1;
  }

  onEditFinished(): void {
    this.onEditMode = false;
  }

  checkIfCanEdit() {
    if (this.isDispatcher) {
      if (this.order.status === 16 || this.order.status === 32) {
        this.canEdit = false;
        if (this.order.status === 16) {
          this.invalidMessage = 'La mission est terminée.';
        } else if (this.order.status === 32) {
          this.invalidMessage = 'La mission a été annulée.';
        } else if (this.order.sender.arrivedOn) {
          this.invalidMessage = 'Le chauffeur est déjà arrivé sur le lieu d\'enlèvement.';
        }
      } else {
        this.canEdit = true;
      }
    } else if (this.isClient) {
      if (this.order.status === 1) {
        this.canEdit = true;
      } else {
        this.canEdit = false;
        this.invalidMessage = 'Il est trop tard pour modifier la commande. Veuillez contacter le support Hemo-Connect.'
      }
    } else {
      this.canEdit = false;
    }
  }

  updateOrder(): void {
    this.ordersSrv.get(this.order.id).subscribe(orderFromSrv => {
      this.order = orderFromSrv;
      this.onEditMode = true;
    });
  }

  public isTour(): boolean {
    if (!this.order) return false;

    return this.order.type === OrderType.tour;
  }

  showTypeText(type: OrderType): string {
    return 'orders.type.' + OrderType[type];
  }
}
